"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInboxMessages = exports.createGetInboxMessagesQuery = exports.messagesProps = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var messagesProps = "\n  totalCount\n  pageInfo {\n    startCursor\n    hasNextPage\n  }\n  nodes {\n    actions(version: 2) {\n      background_color\n      data\n      content\n      href\n      style\n    }\n    archived\n    created\n    data\n    icon\n    messageId\n    opened\n    pinned {\n      slotId\n    }\n    preview\n    read\n    icon\n    tags\n    title\n    trackingIds {\n      openTrackingId\n      archiveTrackingId\n      clickTrackingId\n      deliverTrackingId\n      readTrackingId\n      unreadTrackingId\n    }\n  }\n";
exports.messagesProps = messagesProps;

var createGetInboxMessagesQuery = function createGetInboxMessagesQuery(includePinned) {
  return "\n  query GetInboxMessages($params: FilterParamsInput, ".concat(includePinned ? "$pinnedParams: FilterParamsInput, " : "", " $limit: Int = 10, $after: String){\n    ").concat(includePinned ? "\n      pinned: messages(params: $pinnedParams, limit: $limit, after: $after) {\n        ".concat(messagesProps, "\n      }\n    ") : "", "\n    messages(params: $params, limit: $limit, after: $after) {\n      ").concat(messagesProps, "\n    }\n  }\n");
};

exports.createGetInboxMessagesQuery = createGetInboxMessagesQuery;

var getInboxMessages = function getInboxMessages(client) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, after) {
      var _results$data, _results$data$message, _results$data2, _results$data2$pinned, _results$data3, _results$data3$messag, _results$data3$messag2;

      var _ref2, limit, tenantId, restParams, results, messages, pinned, startCursor;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (client) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", Promise.resolve(undefined));

            case 2:
              _ref2 = params !== null && params !== void 0 ? params : {}, limit = _ref2.limit, tenantId = _ref2.tenantId, restParams = (0, _objectWithoutProperties2["default"])(_ref2, ["limit", "tenantId"]);
              _context.next = 5;
              return client.query(createGetInboxMessagesQuery(!after), {
                after: after,
                limit: limit,
                params: _objectSpread(_objectSpread({}, restParams), {}, {
                  // [HACK] map tenantId to accountId in order to keep this backwards compatible
                  accountId: tenantId,
                  pinned: false
                }),
                pinnedParams: _objectSpread(_objectSpread({}, restParams), {}, {
                  pinned: true
                })
              }).toPromise();

            case 5:
              results = _context.sent;
              messages = results === null || results === void 0 ? void 0 : (_results$data = results.data) === null || _results$data === void 0 ? void 0 : (_results$data$message = _results$data.messages) === null || _results$data$message === void 0 ? void 0 : _results$data$message.nodes;
              pinned = results === null || results === void 0 ? void 0 : (_results$data2 = results.data) === null || _results$data2 === void 0 ? void 0 : (_results$data2$pinned = _results$data2.pinned) === null || _results$data2$pinned === void 0 ? void 0 : _results$data2$pinned.nodes;
              startCursor = results === null || results === void 0 ? void 0 : (_results$data3 = results.data) === null || _results$data3 === void 0 ? void 0 : (_results$data3$messag = _results$data3.messages) === null || _results$data3$messag === void 0 ? void 0 : (_results$data3$messag2 = _results$data3$messag.pageInfo) === null || _results$data3$messag2 === void 0 ? void 0 : _results$data3$messag2.startCursor;
              return _context.abrupt("return", {
                appendMessages: Boolean(after),
                messages: messages,
                pinned: pinned,
                startCursor: startCursor
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getInboxMessages = getInboxMessages;